/* QUANTICA · <q-perk>
   Captura de email con la recompensa adentro. Lo usan el bloque de compra
   de la PDP, el footer y la seccion Newsletter.

   EL ENVIO ES NATIVO, A PROPOSITO. La primera version lo mandaba con
   fetch para no recargar la pagina, y fallaba SIEMPRE: Shopify protege
   los formularios de contacto con un reCAPTCHA invisible y el token lo
   inyecta su propio script al interceptar el submit nativo. Un fetch
   armado a mano se saltea ese paso y la respuesta es
   400 "Missing CAPTCHA token", asi que el cartel mostraba el error
   aunque el mail estuviera perfecto. Medido en la pagina el 18/09.

   No hay forma de pedir ese token desde el theme. Entonces el submit va
   nativo, la pagina recarga, y el codigo lo resuelve Liquid con
   form.posted_successfully?. El id del form viaja en el action como
   ancla, asi que el navegador vuelve al cartel en lugar de arriba de todo.

   Lo unico que hace el JS ahora es tapar el costo de esa recarga: guarda
   el tramo de cantidad elegido antes de irse para que q-buybox lo reponga
   al volver. Sin eso, suscribirse desde la PDP te devolvia a "1 bolsa".
   En footer y newsletter no hay tramos y la busqueda simplemente no
   encuentra nada: el listener no hace nada y no molesta.

   OJO: en una pagina puede haber mas de un <q-perk> (PDP + newsletter +
   footer). Cada uno trae su propio form con id unico; este archivo no
   asume que hay uno solo. */

(function () {
  var TRAMO_GUARDADO = 'q-perk-tier';

  /* EL DESAFIO DE reCAPTCHA.

     Shopify protege los form 'customer' con un reCAPTCHA invisible. Cuando
     su puntaje de riesgo sube —tipicamente por muchos envios seguidos desde
     el mismo navegador, que es lo que pasa probando— deja de ser invisible y
     manda a una pagina de desafio: "To continue, let us know you're not a
     robot" con un boton Submit. Eso es comportamiento normal de Shopify, no
     del theme, y se apaga (a costa de quedar expuesto a bots reales) en
     Tienda online > Preferencias > reCAPTCHA.

     Lo que SI es un bug conocido —Shopify/liquid#1649, abierto— es como se
     ve esa pagina. Nuestros forms llevan id para que, despues de un alta
     exitosa, el navegador vuelva al bloque en vez de al tope de la pagina.
     Shopify arma el action con ese id como ancla, y cuando el envio cae en
     el desafio la URL se lleva el ancla puesta: el navegador salta al
     elemento en vez de al desafio, y lo que se ve es una pagina cortada con
     un boton suelto.

     El ancla vale la pena y el desafio no se puede evitar, asi que lo que se
     arregla es lo unico arreglable: si la pagina es la del desafio, lo
     traemos al centro de la vista. Se corre dos veces porque el salto al
     ancla y el reflow de las imagenes pueden pisar el primer intento. */
  function centrarDesafio() {
    var caja = document.querySelector('.shopify-challenge__container');
    if (!caja) return;
    try {
      caja.scrollIntoView({ block: 'center', behavior: 'auto' });
    } catch (e) {
      caja.scrollIntoView();
    }
  }

  centrarDesafio();
  window.addEventListener('load', centrarDesafio);

  if (customElements.get('q-perk')) return;

  customElements.define('q-perk', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.codeEl = this.querySelector('[data-perk-code]');
      this.copyBtn = this.querySelector('[data-perk-copy]');

      if (this.copyBtn) {
        this.copyBtn.addEventListener('click', function () { this.copiar(); }.bind(this));
      }

      /* El submit NO se previene: solo se anota que tramo estaba elegido
         para poder reponerlo del otro lado de la recarga. */
      if (this.form) {
        this.form.addEventListener('submit', function () {
          var activo = document.querySelector('[data-tier][aria-pressed="true"]');
          if (!activo) return;
          try {
            sessionStorage.setItem(TRAMO_GUARDADO, activo.getAttribute('data-qty') || '');
          } catch (e) {
            /* Modo privado o cookies bloqueadas: se pierde el tramo y nada
               mas. No vale la pena frenar el alta por esto. */
          }
        });
      }
    }

    copiar() {
      var txt = (this.codeEl && this.codeEl.textContent.trim()) || '';
      if (!txt) return;

      var listo = function () {
        var antes = this.copyBtn.textContent;
        this.copyBtn.textContent = this.copyBtn.getAttribute('data-copied') || antes;
        this.copyBtn.setAttribute('data-ok', '');
        setTimeout(function () {
          this.copyBtn.textContent = antes;
          this.copyBtn.removeAttribute('data-ok');
        }.bind(this), 1800);
      }.bind(this);

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(txt).then(listo).catch(function () { this.seleccionar(); }.bind(this));
      } else {
        this.seleccionar();
      }
    }

    /* Sin permiso de portapapeles —o sin https— al menos deja el codigo
       seleccionado para que un Ctrl+C alcance. */
    seleccionar() {
      if (!this.codeEl || !window.getSelection) return;
      var r = document.createRange();
      r.selectNodeContents(this.codeEl);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(r);
    }
  });
})();
